import 'css-chunksrc/client/pages/projectPage/wbsPage/statuses/styles.scss';export default {
  "statuses": "_statuses_n2n15_1",
  "name": "_name_n2n15_5",
  "loader": "_loader_n2n15_16",
  "loaderMain": "_loaderMain_n2n15_24",
  "hideTasks": "_hideTasks_n2n15_31",
  "noTasksFound": "_noTasksFound_n2n15_35",
  "placeholder": "_placeholder_n2n15_41",
  "dropPreview": "_dropPreview_n2n15_57"
};